import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/lib/motion";
import { STANDARDS } from "@/data/content";

const STANDARDS_IMG = "https://images.pexels.com/photos/36150844/pexels-photo-36150844.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function Standards() {
  return (
    <div data-testid="standards-page" className="pt-20">
      <section className="relative overflow-hidden border-b border-steel-border">
        <img src={STANDARDS_IMG} alt="" className="absolute inset-0 h-full w-full object-cover opacity-25 grayscale contrast-110" />
        <div className="absolute inset-0 bg-steel-bg/40" />
        <div className="relative mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-40">
          <Reveal>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-steel-brass">Our Standards</p>
            <h1 className="mt-6 max-w-4xl font-display text-4xl font-medium leading-[1.05] tracking-tight text-steel-text sm:text-6xl">
              What you can expect from Steele Industries.
            </h1>
            <p className="mt-8 max-w-2xl text-base leading-relaxed text-steel-secondary sm:text-lg">
              Seven commitments, applied to every return. Not aspirations — operating procedure.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-5xl px-6 py-24 lg:px-10">
        {STANDARDS.map((s) => (
          <Reveal key={s.n}>
            <div data-testid={`standard-${s.n}`} className="grid grid-cols-1 gap-6 border-b-[3px] border-double border-steel-border py-14 sm:grid-cols-12">
              <div className="sm:col-span-3">
                <span className="font-mono text-5xl text-steel-brass sm:text-6xl">{s.n}</span>
              </div>
              <div className="sm:col-span-9">
                <h2 className="font-display text-3xl font-medium tracking-tight text-steel-text sm:text-4xl">{s.title}</h2>
                <p className="mt-4 max-w-2xl text-base leading-relaxed text-steel-secondary sm:text-lg">{s.desc}</p>
              </div>
            </div>
          </Reveal>
        ))}
        <Reveal delay={0.1}>
          <Link
            to="/get-started"
            data-testid="standards-start-btn"
            className="group mt-14 inline-flex items-center gap-2 bg-steel-accent px-8 py-4 text-sm font-semibold text-white transition-colors duration-300 hover:bg-steel-accentHover"
          >
            Experience the Standard
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </Reveal>
      </section>
    </div>
  );
}
